// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__ivvuS","right":"styles_right__30WND"};